/* eslint-disable linebreak-style */
import styled from 'styled-components';

export const GridStatusAcompanhamentos = styled.div`
  display: flex;
  grid-gap: 10px;
  align-items: center;
  margin-bottom: 40px;

  @media screen and (max-width: 800px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: flex-end;
  }
`;

export const GridAcompanhamentos = styled.div`
  display: grid;
  user-select: text;

  @media screen and (max-width: 600px) {
    padding-bottom: 50px;
  }

  @media screen and (min-width: 800px) {
    grid-template-columns: 200px 1fr;
  }
`;

export const GridProtocolosAcompanhamentos = styled.div`
  max-height: 270px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-corner {
    background-color: #fbfaf5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dfe4ea;
  }

  @media screen and (min-width: 800px) {
    min-height: 68.4vh;
    max-height: 78.4vh;
  }
`;

export const ProtocoloAcompanhamento = styled.div`
  padding: 20px 7px;
  border-bottom: 1px solid #F9F9F9;
  cursor: pointer;
  border-radius: 4px 0px 0px 4px;
  transition: 0.3s;
  background-color: ${({ ativo }) => (ativo ? '#F9F9F9' : 'transparent')};

  :hover {
    background-color: #F9F9F9;
  }
`;

export const ProtocoloAcompanhamentoTitulo = styled.h4`
  color: #000;
  font-size: 14.5px;
  line-height: normal;
  margin-block: 0 5px;
  display: flex;
  grid-gap: 5px;
  align-items: center;

  > img {
    height: 17px;
    width: 17px;
  }
`;

export const ProtocoloAcompanhamentoDataHora = styled.span`
  font-size: 13px;
`;

export const ConteudoProtocoloAcompanhamento = styled.div`
  background-color: #F9F9F9;
  border-radius: 0px 4px 4px 4px;
  padding: 15px;
`;
